import { render } from "./LineLoginView.vue?vue&type=template&id=20084058&ts=true"
import script from "./LineLoginView.vue?vue&type=script&lang=ts"
export * from "./LineLoginView.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__